<!--  -->
<template>
  <div class="we-view">
    <vue-ueditor-wrap
      v-model="content"
      @ready="ready"
      @beforeInit="addCustomDialog"
      :config="myConfig"
      :destroy="true"
    />
    <div v-show="dialogVisible">
      <el-upload
        v-loading.fullscreen.lock="fullscreenLoading"
        action="#"
        accept=".jpg,.png,.jepg"
        :http-request="uploadImg"
        :before-upload="beforeUpload"
        :on-success="handleSuccess"
        :on-progress="uploadIng"
      >
        <el-button size="small" class="uploadImgBtn" type="primary"
          >上传图片</el-button
        >
      </el-upload>
    </div>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import FileHandler from "@/utils/file";
export default {
  data() {
    return {
      content: "",
      editorInstance: {},
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口（这个地址不用管）
        serverUrl: "",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: "/UEditor/",
      },
      dialogVisible: false,
      fullscreenLoading: false,
      addImage: require("@/assets/image/btn/upload_file_icon.png"),
    };
  },

  props: ["detail", "uploadUrl", "isDisabled"],

  components: {
    VueUeditorWrap,
  },
  watch: {
    content(val) {
      this.$emit("change-con", val);
    },
    detail(val) {
      this.content = val;
    },
  },

  computed: {},

  mounted() {},

  methods: {
    handleSuccess() {
      this.fullscreenLoading = false;
    },
    uploadIng() {
      this.fullscreenLoading = true;
    },
    beforeUpload(file) {
      let types = ["image/jpeg", "image/jpg", "image/png"];
      const isImage = types.includes(file.type);
      if (!isImage) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG 格式!");
        return false;
      } else {
        return true;
      }
    },
    uploadImg(data) {
      let file = data.file;
      let uploadUrl = this.uploadUrl;
      FileHandler.uploadFile(uploadUrl, file).then((res) => {
        this.fullscreenLoading = false;
        this.editorInstance.execCommand("insertimage", {
          src: res.url,
        });
        this.dialogVisible = false;
      });
    },
    addCustomDialog() {
      let that = this;
      window.UE.registerUI("test-dialog", function (editor, uiName) {
        // 参考http://ueditor.baidu.com/doc/#COMMAND.LIST
        var btn = new window.UE.ui.Button({
          name: "dialog-button",
          title: "上传图片",
          cssRules: `background-image: url(${that.addImage}) !important;background-size: cover;`,
          onclick: function () {
            // that.dialogVisible = true
            document.querySelector(".uploadImgBtn").click();
            editor.execCommand(uiName);
          },
        });
        return btn;
      });
    },
    ready(editorInstance) {
      if (this.isDisabled) {
        this.editorInstance = editorInstance;
        // 不是编辑状态，禁用编辑，隐藏工具栏
        this.editorInstance.body.contentEditable = false;
      } else {
        this.editorInstance = editorInstance;
        this.content = this.detail;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.we-view {
  padding: 5px 0;
}
</style>
